import { render } from "./NavBarBussiness.vue?vue&type=template&id=4502219e&scoped=true"
import script from "./NavBarBussiness.vue?vue&type=script&lang=js"
export * from "./NavBarBussiness.vue?vue&type=script&lang=js"

import "./NavBarBussiness.vue?vue&type=style&index=0&id=4502219e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4502219e"]])

export default __exports__